import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

// Note: You can change "images" to whatever you'd like.

const GatsbyImage = props => {
  return (
    <StaticQuery
      query={graphql`
        query {
          images: allFile {
            edges {
              node {
                relativePath
                name
                publicURL
                extension
                childImageSharp {
                  fluid(maxWidth: 1440, quality: 100) {
                    ...GatsbyImageSharpFluid_withWebp_noBase64
                  }
                }
              }
            }
          }
        }
      `}
      render={data => {
        const image = data.images.edges.find(n => {
          return n.node.relativePath.includes(props.imageName)
        })

        if (!image) {
          return null
        }

        const { childImageSharp, publicURL, extension } = image.node
        if (!childImageSharp && extension === "svg") {
          return (
            <img
              src={publicURL}
              alt={props.alt || ""}
              class={props.className || ""}
            />
          )
        }

        return (
          <Img
            alt={props.alt}
            fluid={childImageSharp.fluid}
            style={props.styles}
            loader={props.loading}
            className={props.className}
          />
        )
      }}
    />
  )
}

export default GatsbyImage
